import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Col, FormControl } from 'react-bootstrap';
import * as Icons from "@fortawesome/free-solid-svg-icons";
import TableTemplate from '../../components/TableTemplate';
import { bpOrderOperations } from "./state";
import { EMPTY_STRING, PROPOSAL_ID } from '../../../utils/constants';

class BPOrderProposalModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            businessPartnerCode: this.props.credentials.riyo_kigyo_id,
            proposalId: EMPTY_STRING,
            proposalName: EMPTY_STRING,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.showModal !== prevProps.showModal) {
            this.setState({  proposalId: EMPTY_STRING, proposalName: EMPTY_STRING });
        }
      }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    searchProposal = () => {
        this.props.fetchDefault(this.state)
    }

    searchFields() {
        let MAX_ID_LENGTH = 3;
        let MAX_DEFAULT_LENGTH = 40;

        return (
            this.props.searchFields.map((field, i) => {
                return (
                    <div className={0 === i && "modal-container-height" } key={i}>
                        <Col sm={4} className={"modal-label"}>{field.label}</Col>
                        <Col sm={5} className="modal-row-field no-padding">
                            <FormControl
                                type="text"
                                maxLength={PROPOSAL_ID === field.name ? MAX_ID_LENGTH : MAX_DEFAULT_LENGTH}
                                name={field.name}
                                value={this.state[field.name]}
                                onChange={this.handleInputChange}
                                className="form-input"
                            />
                        </Col>
                    </div>
                )
            })
        )
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.toggleModal}>

                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="modal-row">
                        {this.searchFields()}
                    </div>
                    <Button
                        className="button-filter proposal-search"
                        onClick={() => this.searchProposal()}
                    >
                        商品提案G 検索
                        </Button>

                    <TableTemplate
                        {...this.props}
                        tableName="proposal-table"
                        rowButtons={[
                            {
                                onClick: this.props.searchProposal,
                                icon: Icons.faArrowAltCircleRight,
                                bsStyle: "link"
                            }
                        ]}
                    />
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        searchFields: state.bpOrder.searchFields,
        tableHeader: state.bpOrder.proposalHeader,
        tableList: state.bpOrder.proposalList,
        tableColumns: state.bpOrder.proposalColumns,
        credentials: state.auth.credentials,
    }
};

const mapDispatchToProps = {
    fetchDefault: bpOrderOperations.fetchProposal,
};

export default connect(mapStateToProps, mapDispatchToProps)(BPOrderProposalModal);